/**
 *  ・クラス名
 *    予定原価入力モデル
 *  ・概要
 *    請求書関連に必要な処理を記述
 *  ・更新履歴
 *    2021/01/29 新規作成 小林
 *    2021/02/10 コメント整理 小林
 */
import BaseModel from './baseModel';

export default class FixedCostInputLaborCost extends BaseModel {
  private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};
  private employeeReport?: Array<{ [k: string]: string | undefined }> = [];

  constructor() {
    super();
  }

  /**
   * 各種入力フォームで使用する各マスタ情報を取得
   * プロパティーに格納します
   * @param none
   * @returns void
   */
  public async getMasterData() {
    const mData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};
  }

  /**
   * マスタ情報を取得します
   * @returns {array} - マスタ情報配列
   */
  public getMaster() {
    return this.masterData;
  }

  /**
   * データレポートから取得した社員情報を取得します
   * @returns {array} - 社員情報配列
   */
  public getEmployeeReport() {
    return this.employeeReport;
  }
}
